// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fontawesome-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fontawesome-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fontawesome-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fontawesome-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fontawesome-webfont.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @font-face {
  font-family: "FontAwesome";
  src: url("../fonts/fontawesome-webfont.eot");
  src: url("../fonts/fontawesome-webfont.eot") format("embedded-opentype"), url("../fonts/fontawesome-webfont.woff2") format("woff2"),
    url("../fonts/fontawesome-webfont.woff") format("woff"), url("../fonts/fontawesome-webfont.ttf") format("truetype"),
    url("../fonts/fontawesome-webfont.svg") format("svg");
  font-weight: normal;
  font-style: normal;
} */

@font-face {
  font-family: "FontAwesome";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;
}

.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.fa-sm {
  font-size: 0.875em;
  line-height: 0.75em;
  vertical-align: -15%;
}
.fa-lg {
  font-size: 1.25em;
  line-height: 0.75em;
  vertical-align: -15%;
}
.fa-xl {
  font-size: 1.5em;
  line-height: 0.75em;
  vertical-align: -15%;
}
.fa-2x {
  font-size: 2em;
}
.fa-3x {
  font-size: 3em;
}
.fa-4x {
  font-size: 4em;
}
.fa-5x {
  font-size: 5em;
}
.fa-fw {
  width: 1.28571429em;
  text-align: center;
}
.fa-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}
.fa-ul > li {
  position: relative;
}

.fa-comment:before {
  content: "\\f075";
}
.fa-comments:before {
  content: "\\f086";
}

.fa-window-minimize:before {
  content: "\\f2d1";
}

.fa-times:before {
  content: "\\f00d";
}

.fa-send-o:before,
.fa-paper-plane-o:before {
  content: "\\f1d9";
}

.fa-arrow-right:before {
  content: "\\f061";
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/font-awesome.min.css"],"names":[],"mappings":"AAAA;;;;;;;;GAQG;;AAEH;EACE,0BAA0B;EAC1B,4CAAmC;EACnC;qHACiG;EACjG,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* @font-face {\n  font-family: \"FontAwesome\";\n  src: url(\"../fonts/fontawesome-webfont.eot\");\n  src: url(\"../fonts/fontawesome-webfont.eot\") format(\"embedded-opentype\"), url(\"../fonts/fontawesome-webfont.woff2\") format(\"woff2\"),\n    url(\"../fonts/fontawesome-webfont.woff\") format(\"woff\"), url(\"../fonts/fontawesome-webfont.ttf\") format(\"truetype\"),\n    url(\"../fonts/fontawesome-webfont.svg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n} */\n\n@font-face {\n  font-family: \"FontAwesome\";\n  src: url(\"fontawesome-webfont.eot\");\n  src: url(\"fontawesome-webfont.eot\") format(\"embedded-opentype\"), url(\"fontawesome-webfont.woff2\") format(\"woff2\"), url(\"fontawesome-webfont.woff\") format(\"woff\"),\n    url(\"fontawesome-webfont.ttf\") format(\"truetype\"), url(\"fontawesome-webfont.svg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.fa {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n.fa-2x {\n  font-size: 2em;\n}\n.fa-3x {\n  font-size: 3em;\n}\n.fa-4x {\n  font-size: 4em;\n}\n.fa-5x {\n  font-size: 5em;\n}\n.fa-fw {\n  width: 1.28571429em;\n  text-align: center;\n}\n.fa-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-comment:before {\n  content: \"\\f075\";\n}\n.fa-comments:before {\n  content: \"\\f086\";\n}\n\n.fa-window-minimize:before {\n  content: \"\\f2d1\";\n}\n\n.fa-times:before {\n  content: \"\\f00d\";\n}\n\n.fa-send-o:before,\n.fa-paper-plane-o:before {\n  content: \"\\f1d9\";\n}\n\n.fa-arrow-right:before {\n  content: \"\\f061\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
